import { useMemo } from 'react';

import type { ITheme } from '../../../util/theme';
import { defaultTheme } from '../../../util/theme';
import { getGlobalComponentStyleOverrides } from '../../../util/theme/getGlobalComponentStyleOverrides.styles';

type UseThemeWithComponentStyleOverrides = (theme?: ITheme) => ITheme;
export const useThemeWithComponentStyleOverrides: UseThemeWithComponentStyleOverrides = (theme = defaultTheme) =>
  useMemo(
    () => ({
      ...theme,
      components: getGlobalComponentStyleOverrides(theme),
    }),
    [theme]
  );
